// extracted by mini-css-extract-plugin
export default {"inner":"Tireurs_inner__RJOrA","head":"Tireurs_head__r68--","info":"Tireurs_info__RUNxz","wrapper":"Tireurs_wrapper__0uGVa","button":"Tireurs_button__5Dqar"};